import { call, put, takeLatest } from 'redux-saga/effects';
import OrganizationSurvey from '../../api/organizationSurvey';
import { actionTypes, getOrganizationSurveysSuccess } from '../actions/organizationSurvey';

function* getOrganizationSurvey(action) {
  try {
    const result = yield call(() => OrganizationSurvey.getOrganizationSurvey(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* createOrganizationSurveyAnswers(action) {
  try {
    const result = yield call(() =>
      OrganizationSurvey.createOrganizationSurveyAnswers(action.payload.id, action.payload),
    );
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* handleSurveyLock(action) {
  try {
    const result = yield call(() => OrganizationSurvey.handleSurveyLock(action.payload.id, action.payload));
    action.callback(result?.isLockedBy);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* submitSurvey(action) {
  try {
    yield call(() => OrganizationSurvey.submitSurvey(action.payload));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* getOrganizationSurveys(action) {
  try {
    const result = yield call(() => OrganizationSurvey.getOrganizationSurveys(action.payload));
    yield put(getOrganizationSurveysSuccess(result));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* resetOrganizationSurveys() {
  try {
    yield put(getOrganizationSurveysSuccess({ organizationSurveys: [], count: 0, dropdownValues: {} }));
  } catch (error) {
    console.log(error);
  }
}

export default function* organizationSurveySaga() {
  yield takeLatest(actionTypes.GET_ORGANIZATION_SURVEY, getOrganizationSurvey);
  yield takeLatest(actionTypes.CREATE_ORGANIZATION_SURVEY, createOrganizationSurveyAnswers);
  yield takeLatest(actionTypes.LOCK_SURVEY, handleSurveyLock);
  yield takeLatest(actionTypes.SUBMIT_SURVEY, submitSurvey);
  yield takeLatest(actionTypes.GET_ORGANIZATION_SURVEYS, getOrganizationSurveys);
  yield takeLatest(actionTypes.RESET_ORGANIZATION_SURVEYS, resetOrganizationSurveys);
}
